<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-data-visualization`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 44H4a1 1 0 01-1-1v-2a1 1 0 011-1h1V23.09C5 21.937 5.96 21 7.143 21H16V6.105C16 4.943 17.023 4 18.286 4h11.428C30.977 4 32 4.943 32 6.105V16h8.857c1.184 0 2.143.895 2.143 2v22h1a1 1 0 011 1v2a1 1 0 01-1 1zM16 25H9v15h7V25zM28 8h-8v32h8V8zm11 12h-7v20h7V20z"/></svg>
</template>
<script>

export default {
  name: 'IconDataVisualization',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
